export default __webpack_public_path__ + "6ea07f7567af2dac9a8965f66f64a1c3.png";